/**
 * Extracted from marketplaceItemSchema.ts to avoid circular dependency:
 * marketplaceItemSchema → collectibles barrel → collectiblesHelpers → collection/item barrel → collectionItemSchema → marketplaceItemSchema
 */
import { WholeNumber_Schema } from "@/utilities/schema";

export const MarketplaceItemId_Schema = WholeNumber_Schema;
